import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { base_path } from "./environment";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/style/css/feather.css";
import "../src/index.scss";
import store from "./core/data/redux/store";
import { Provider } from "react-redux";
import "../src/style/icon/boxicons/boxicons/css/boxicons.min.css";
import "../src/style/icon/weather/weathericons.css";
import "../src/style/icon/typicons/typicons.css";
import "../src/style/icon/fontawesome/css/fontawesome.min.css";
import "../src/style/icon/fontawesome/css/all.min.css";
import "../src/style/icon/ionic/ionicons.css";
import "../src/style/icon/tabler-icons/webfont/tabler-icons.css";
import ALLRoutes from "./feature-module/router/router";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import { GoogleOAuthProvider } from "@react-oauth/google";

// Protection component
const DevToolsProtection = () => {
    React.useEffect(() => {
        // Disable right-click
        const handleContextMenu = (e: MouseEvent) => {
            e.preventDefault();
        };

        // Disable keyboard shortcuts
        const handleKeyDown = (e: KeyboardEvent) => {
            if (
                e.key === 'F12' ||
                (e.ctrlKey && e.shiftKey && e.key === 'I') || // Chrome/Edge/Opera
                (e.ctrlKey && e.shiftKey && e.key === 'J') || // Chrome/Edge/Opera
                (e.ctrlKey && e.key === 'U') || // View source
                (e.metaKey && e.altKey && e.key === 'I') || // Mac
                (e.ctrlKey && e.shiftKey && e.key === 'C') // Chrome DevTools
            ) {
                e.preventDefault();
            }
        };

        // Detect devtools open attempts
        const devtoolsCheck = () => {
            const before = new Date().getTime();
            (() => {})['constructor']('debugger')();
            const after = new Date().getTime();
            if (after - before > 100) {
                document.body.innerHTML = '<h1 style="text-align:center;margin-top:50px;">Developer tools are disabled</h1>';
            }
        };

        // Set up event listeners
        document.addEventListener('contextmenu', handleContextMenu);
        document.addEventListener('keydown', handleKeyDown);

        // Run devtools check periodically
        const interval = setInterval(devtoolsCheck, 1000);

        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
            document.removeEventListener('keydown', handleKeyDown);
            clearInterval(interval);
        };
    }, []);

    return null; // This component doesn't render anything
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
      <GoogleOAuthProvider clientId="YOUR_GOOGLE_CLIENT_ID">
    <Provider store={store}>
      <BrowserRouter basename={base_path}>
          <DevToolsProtection />
        <ALLRoutes />
      </BrowserRouter>
    </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
